<template>
    <div class="light-color-bg position-relative ">
        <div v-if="activeQuestion" class="justify-full-height">
            <div v-for="(moduleItem, index) in activeQuestion.modules" :key="index">
                <QuestionTitle v-if="moduleItem.name === 'QuestionTitle'" :number="moduleItem.number"
                    :question="moduleItem.question" :comment="moduleItem.comment"
                    :modalActivator="moduleItem.modalActivator" @activateModal="modalActive = true"
                    :modalActive="modalActive"></QuestionTitle>
                <div class="container-70" v-if="moduleItem.name === 'NbCalculator'">
                    <NbCalculator :img="moduleItem.img" :listOfInputs="moduleItem.listOfInputs" v-model="result"
                        @onError="(e) => error = e"></NbCalculator>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'InputBox'">
                    <InputBox :img="moduleItem.img" :inputInfo="moduleItem.inputInfo" :textAlign="moduleItem.textAlign"
                        v-model="result" @onError="(e) => error = e"></InputBox>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'GeocoderDistance'">
                    <GeocoderDistance :img="moduleItem.img" v-model="result"></GeocoderDistance>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'SelectOptionBox'">
                    <SelectOptionBox v-if="moduleItem.resultLabel" :img="moduleItem.img" :label="moduleItem.label"
                        :options="moduleItem.options" v-model="result[moduleItem.resultLabel]"
                        :style="{ 'z-index': 1000 - index }"></SelectOptionBox>
                    <SelectOptionBox v-else :img="moduleItem.img" :options="moduleItem.options"
                        :label="moduleItem.label" v-model="result" :style="{ 'z-index': 1000 - index }">
                    </SelectOptionBox>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'SelectionBox'">
                    <SelectionBox :values="moduleItem.options" v-model="result"
                        @update:modelValue="saveAndContinue(activeQuestion.resultLabel, JSON.stringify(result), activeQuestion.next)">
                    </SelectionBox>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'DetailDistanceCalculator'">
                    <DetailDistanceCalculator v-model="result" @onError="(e) => error = e"></DetailDistanceCalculator>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'LodgingCalculator'">
                    <LodgingCalculator v-model="result" @update:modelValue="bypass(activeQuestion)"
                        @onError="(e) => error = e"></LodgingCalculator>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'AlimentationCalculator'">
                    <AlimentationCalculator v-model="result" @onError="(e) => error = e"
                        :description="moduleItem.description"></AlimentationCalculator>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'ActivityCalculator'">
                    <ActivityCalculator v-model="result" @onError="(e) => error = e"></ActivityCalculator>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'DoubleButtonChoice'">
                    <DoubleButtonChoice :button1="moduleItem.button1" :button2="moduleItem.button2"
                        :bold="moduleItem.bold" v-model="result" class="mt-100px"
                        :wrap="moduleItem.wrap"
                        @update:modelValue="saveAndContinue(activeQuestion.resultLabel, JSON.stringify(result.label), result.link)">
                    </DoubleButtonChoice>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'AccordeonBox'">
                    <AccordeonBox :headerText="moduleItem.headerText" :bodyText="moduleItem.bodyText" bgColor="#96D3DD" class="mt-65px">
                    </AccordeonBox>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'DetailDistanceCalculatorEvent'">
                    <DetailDistanceCalculatorEvent :globalQuestions="moduleItem.globalQuestions"
                        :commentTransport='moduleItem.commentTransport'
                        :transportsQuestions="moduleItem.transportsQuestions" :smallUnit="moduleItem.smallUnit"
                        :ponderationActive="moduleItem.ponderationActive" :transportTitle="moduleItem.transportTitle"
                        v-model="result" @onError="(e) => error = e"></DetailDistanceCalculatorEvent>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'ConsommationEnergetique'">
                    <ConsommationEnergetique v-model="result" :energies="moduleItem.energies"></ConsommationEnergetique>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'HydroOnly'">
                    <HydroOnly v-model="result"
                        @click="saveAndContinue(activeQuestion.resultLabel, JSON.stringify(result), activeQuestion.next)">
                    </HydroOnly>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'MultipleInput'">
                    <MultipleInput :img="moduleItem.img" :listOfInput="moduleItem.listOfInput" v-model="result">
                    </MultipleInput>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'SuperficieEvent'">
                    <SuperficieEvent v-model="result" :img="moduleItem.img" :label="moduleItem.label"></SuperficieEvent>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'VehicleType'">
                    <VehicleType :listOfInputs="moduleItem.listOfInputs" v-model="result"></VehicleType>
                </div>
                <div v-if="moduleItem.name === 'GaugeQuestion'">
                    <GaugeQuestion v-model="result"  @onError="(e) => error = e"></GaugeQuestion>
                </div>
                <div class="container-70" v-if="moduleItem.name === 'SubmitButton'">
                    <div v-if="result !== null && (typeof result !== 'object' || Object.keys(result).length !== 0) && !error"
                        @click="saveAndContinue(activeQuestion.resultLabel, JSON.stringify(result), activeQuestion.next)"
                        class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
                </div>
                <div class="container-70 mt-20px">
                    <AvancementLine v-if="moduleItem.name === 'AvancementLine'" :percent="moduleItem.percent">
                    </AvancementLine>
                </div>
                <ModalInfo @closeModal="modalActive = false" v-if="modalActive">
                    <div v-if="moduleItem.multiplePages && isTouch">
                        <div v-for="(page, index) in moduleItem.pages" :key="index">
                            <div v-if="modalPage == index">
                                <h3 class="modal-title">{{ page.title }}</h3>
                                <p class="modal-text" v-html="page.body"></p>
                                <div v-if="page.options">
                                    <div v-for="(option, subindex) in page.options" :key="subindex"
                                        class="d-flex vertical-center">
                                        <div class="col-15 no-shrink">
                                            <img :src="option.img" class="modal-img" />
                                        </div>
                                        <div>
                                            <p class="modal-text ml-20px"><b>{{ option.label }}</b><br/>
                                            {{ option.description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nextModal" @click="modalPage =  modalPage+1"
                            v-if="modalPage + 1 !== moduleItem.pages.length">
                            Page suivante</div>
                        <div class="previousModal" @click="modalPage = modalPage - 1" v-if="modalPage !== 0">Page précédente
                        </div>
                    </div>
                    <div v-else-if="moduleItem.multiplePages && !isTouch">
                        <h3 class="modal-title">{{ moduleItem.pages[1].title }}</h3>
                        <p class="modal-text" v-html="moduleItem.pages[1].body"></p>
                    </div>
                    <div v-else>
                        <h3 class="modal-title">{{ moduleItem.title }}</h3>
                        <p class="modal-text" v-html="moduleItem.body"></p>
                    </div>
                </ModalInfo>
            </div>
        </div>
        <div v-else>
            <div>404</div>
        </div>
    </div>
</template>
<script>
//Data
import questionnaire from "@/views/questionnaire.json"
//Components
import QuestionTitle from '@/components/QuestionTitle.vue'
import NbCalculator from '@/components/NbCalculator.vue'
import InputBox from '@/components/InputBox.vue'
import GeocoderDistance from '@/components/GeocoderDistance.vue'
import SelectOptionBox from '@/components/SelectOptionBox.vue'
import SelectionBox from '@/components/SelectionBox.vue'
import DetailDistanceCalculator from '@/components/DetailDistanceCalculator.vue'
import LodgingCalculator from '@/components/LodgingCalculator.vue'
import AlimentationCalculator from '@/components/AlimentationCalculator.vue'
import ActivityCalculator from '@/components/ActivityCalculator.vue'
import DoubleButtonChoice from '@/components/DoubleButtonChoice.vue'
import DetailDistanceCalculatorEvent from '@/components/DetailDistanceCalculatorEvent.vue'
import ConsommationEnergetique from '@/components/ConsommationEnergetique.vue'
import HydroOnly from '@/components/HydroOnly.vue'
import SuperficieEvent from '@/components/SuperficieEvent.vue'
import MultipleInput from '@/components/MultipleInput.vue'
import VehicleType from '@/components/VehicleType.vue'
import GaugeQuestion from '@/components/GaugeQuestion.vue'
import AccordeonBox from '@/components/AccordeonBox.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import ModalInfo from '@/components/ModalInfo.vue'


/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result: {},
            error: false,
            questionnaire,
            activeQuestion: null,
            modalActive: false,
            modalPage: 0,
            isTouch: false,
        }
    },
    components: {
        QuestionTitle,
        NbCalculator,
        InputBox,
        GeocoderDistance,
        SelectOptionBox,
        SelectionBox,
        DetailDistanceCalculator,
        LodgingCalculator,
        AlimentationCalculator,
        ActivityCalculator,
        DoubleButtonChoice,
        DetailDistanceCalculatorEvent,
        ConsommationEnergetique,
        HydroOnly,
        SuperficieEvent,
        MultipleInput,
        VehicleType,
        GaugeQuestion,
        AccordeonBox,
        AvancementLine,
        ModalInfo
    },
    methods: {
        fetchData(who, level, question) {
            if (who && level && question) {
                this.activeQuestion = this.questionnaire[who][level].find(element => element.question === question)
                if (this.activeQuestion && sessionStorage.getItem(this.activeQuestion.resultLabel)) {
                    this.result = JSON.parse(sessionStorage.getItem(this.activeQuestion.resultLabel))
                }
            }
            else {
                this.activeQuestion = null
            }
        },
        bypass(activeQuestion) {
            if (this.result['Sans hébergement']) {
                this.saveAndContinue(activeQuestion.resultLabel, JSON.stringify(this.result), activeQuestion.next)
            }
        },
        checkIfTouchDevice() {
            return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        }
    },
    mixins: [utils],
    mounted() {
        let who = this.$route.params.who
        let level = this.$route.params.level
        let question = this.$route.params.question
        this.fetchData(who, level, question)
        this.isTouch = this.checkIfTouchDevice();

    }
}
</script>